<ion-header class="header-mast">
  <ion-toolbar>
    <div class="header-content">
      <div class="logo-section" (click)="navigateToHome()">
        <img src="assets/images/zoe_logo.svg" alt="ZOE Logo" class="logo" />
      </div>

      <span class="vertical-separator"></span>

      @if (activeModule()) {
        <ion-title class="module-title full desktop-only" mode="md">
          <a [routerLink]="activeModule()?.rootPath" class="module-link">
            {{ activeModule()?.full }}
          </a>
        </ion-title>
        <ion-title class="module-title short mobile-only" mode="md">
          <a [routerLink]="activeModule()?.rootPath" class="module-link">
            {{ activeModule()?.short }}
          </a>
        </ion-title>
      }

      <!-- Desktop navigation -->
      <div class="nav-buttons desktop-only">
        @if (navigationService.isAuthenticated()) {
          <ion-button
            fill="clear"
            routerLink="/dashboard"
            routerLinkActive="active"
          >
            Dashboard
          </ion-button>

          @if (navigationService.canViewSayp()) {
            <ion-button
              fill="clear"
              id="sayp-trigger"
              [class.active]="activeModule()?.key === 'sayp'"
            >
              Save As You Pay
            </ion-button>

            <ion-popover
              trigger="sayp-trigger"
              triggerAction="click"
              mode="ios"
              show-backdrop="false"
              #saypPopover
            >
              <ng-template>
                @for (
                  route of navigationService.saypRoutes();
                  track route.path
                ) {
                  <ion-item
                    button
                    (click)="navigateToSaypRoute(route.path)"
                    mode="ios"
                    detail="true"
                    [detailIcon]="route.icon"
                  >
                    <ion-label
                      [color]="
                        navigationService.isRouteActive(route.path)
                          ? 'tertiary'
                          : 'primary'
                      "
                    >
                      {{ route.label }}
                    </ion-label>
                  </ion-item>
                }
              </ng-template>
            </ion-popover>
          }

          <ion-button fill="clear" (click)="signOut()">
            <ion-icon
              name="log-out-outline"
              slot="icon-only"
              size="small"
            ></ion-icon>
          </ion-button>
        } @else {
          <ion-button fill="clear" (click)="signIn()">
            <ion-icon name="log-in-outline" slot="start"></ion-icon> Sign In
          </ion-button>
        }
      </div>

      <!-- Mobile hamburger menu button -->
      <ion-button
        fill="clear"
        class="mobile-only hamburger-btn"
        (click)="onToggleMobileMenu()"
      >
        <ion-icon name="menu-outline" slot="icon-only"></ion-icon>
      </ion-button>
    </div>
  </ion-toolbar>
  @if (showNonprodWarning) {
    <div class="nonprod-banner">
      <strong>Non-Production Environment - For Testing Use Only</strong>
    </div>
  }
</ion-header>
